import $ from 'jquery';
import 'bootstrap';
import enableBackToTopFunctionality from './back-to-top';
import enableHomePageFunctionality from './index';
// wait until the DOM loads
$(() => {
    // enable common functionality
    enableBackToTopFunctionality();
    enableHomePageFunctionality();
});
